import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import UpsellCrossSellChart from "../UpsellCrossSellChart";

const UpsellCrossSellPaper = ({
  classes,
  paperTitle,
  upsellCrossSellData,
  isUpsellCrossSellLoading,
  appliedTeam,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            {/* Upsell-Cross Sell Tracker */}
            {upsellCrossSellData?.title}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        {isUpsellCrossSellLoading ? (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={300}
                width="100%"
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {(() => {
              // When "All" is selected, show Company data; otherwise show selected team's data
              const teamKey =
                appliedTeam && appliedTeam !== "All" ? appliedTeam : "Company";
              const teamData = upsellCrossSellData?.teams?.[teamKey];
              const displayName =
                teamKey === "Company" ? "ColorTokens" : teamKey;

              if (!teamData) return null;

              return (
                <Grid item xs={12}>
                  <Card className={classes.chartCard}>
                    <CardContent>
                      <div className={classes.chartContainer} id="printChart">
                        <UpsellCrossSellChart
                          data={teamData}
                          teamName={displayName}
                          currencySymbol={currencySymbol}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })()}
          </Grid>
        )}

        {/* Legend for cumulative target vs actual */}
        <Box mt={2}>
          <div className={classes.legend}>
            <div className={classes.legendItem}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: "#bf9000" }}
              />
              <Typography variant="body2">Cumulative (target)</Typography>
            </div>
            <div className={classes.legendItem}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: "#70ad47" }}
              />
              <Typography variant="body2">Cumulative (actual)</Typography>
            </div>
          </div>
        </Box>
      </Paper>
    </Grid>
  );
};

export default UpsellCrossSellPaper;
